import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './styles/global.css';
import App from './App';
import { ThemeModeProvider } from './core/contexts/ThemeModeContext';
import { AuthProvider } from './core/contexts/AuthContext';
import { TenantProvider } from './core/contexts/TenantContext';
import { ProjectProvider } from './core/contexts/ProjectContext';

// Vite injects BASE_URL from the `base` config option. Stripping the trailing
// slash gives React Router its `basename` so routes work both at `/` (dev)
// and `/console/` (production behind the backend).
const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={routerBasename}>
          <AuthProvider>
            <TenantProvider>
              <ProjectProvider>
                <App />
              </ProjectProvider>
            </TenantProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeModeProvider>
  </React.StrictMode>,
);
